<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ vehicle.id ? $t('vehicle.form.editTitle') : $t('vehicle.form.newTitle') }}
              </div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form action>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="Name">
                          <span class="required">*</span> {{ $t('vehicle.form.nameLabel') }}
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Name"
                          class="form-control"
                          v-model="vehicle.name"
                          placeholder=""
                        />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="Name">
                          <span class="required">*</span> {{ $t('vehicle.form.plateLabel') }}
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Name"
                          class="form-control"
                          v-model="vehicle.plate"
                          placeholder=""
                        />
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="Name"> {{ $t('vehicle.form.brandLabel') }} </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Name"
                          class="form-control"
                          v-model="vehicle.brand"
                          placeholder=""
                        />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="Name"> {{ $t('vehicle.form.modelLabel') }} </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Name"
                          class="form-control"
                          v-model="vehicle.model"
                          placeholder=""
                        />
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="Name"> {{ $t('vehicle.form.colorLabel') }} </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Name"
                          class="form-control"
                          v-model="vehicle.color"
                          placeholder=""
                        />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="Name"> {{ $t('vehicle.form.cnesLabel') }} </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Name"
                          class="form-control"
                          v-model="vehicle.cnes"
                          placeholder=""
                        />
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col-md-3">
                        <label for="Name"> {{ $t('vehicle.form.renavamLabel') }} </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Name"
                          class="form-control"
                          v-model="vehicle.renavam"
                          placeholder=""
                        />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="Name"> {{ $t('vehicle.form.actualKmLabel') }} </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Name"
                          class="form-control"
                          v-model="vehicle.actual_km"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-3">
                        <label for="Name"> {{ $t('vehicle.form.chassiLabel') }} </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Name"
                          class="form-control"
                          v-model="vehicle.chassi"
                          placeholder=""
                        />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-3">
                        <label for="Name"> {{ $t('vehicle.form.codeLabel') }} </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Name"
                          class="form-control"
                          v-model="vehicle.code"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-3">
                        <label for="Name"> {{ $t('vehicle.form.vehicleTypeLabel') }} </label>
                        <v-select
                          :options="vehicle_types"
                          :reduce="(vehicle_types) => vehicle_types.id"
                          :label="'vehicle_type_name'"
                          v-model="vehicle.vehicle_type_id"
                          class="vselect"
                        />
                      </div>
                      <div class="form-group col-md-3">
                        <label for="Name"> {{ $t('vehicle.form.companyLabel') }} </label>
                        <v-select
                          :options="companies"
                          :reduce="(companies) => companies.id"
                          :label="'name'"
                          v-model="vehicle.tenancy_id"
                          class="vselect"
                        />
                      </div>
                      <div class="form-group col-md-3">
                        <label for="Name"> {{ $t('common.status') }}: </label>
                        <select v-model="vehicle.status" class="form-control">
                          <option :value="1">{{ $t('common.active') }}</option>
                          <option :value="0">{{ $t('common.inactive') }}</option>
                        </select>
                      </div>
                    </div>

                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>{{ $t('vehicle.form.requiredFields') }}</strong>
                    </span>
                    <div class="block text-right">
                      <router-link to="/vehicles" class="btn btn-back mr-1">
                        <i class="fa fa-arrow-left"></i> {{ $t('common.back') }}
                      </router-link>
                      <a v-if="$hasAbility('viatura.gerenciar')" class="btn btn-add" @click="save">
                        {{ $t('common.save') }}
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import Loading from "vue-loading-overlay";

export default {
  data() {
    return {
      vehicle: {
        name: "",
        color: "",
        brand: "",
        model: "",
        vehicle_type_id: "",
        renavam: "",
        actual_km: "",
        chassi: "",
        plate: "",
        code: "",
        ares_frota_id: "",
        current_vehicle_position_type: "",
        status: "1",
        tenancy_id: "",
      },
      vehicle_types: [],
      companies: [],
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "vehicles";

      self.$loading(true);

      if (self.vehicle.id) {
        self.vehicle._method = "PUT";
        api += "/" + self.vehicle.id;
      }

      axios
        .post(api, self.vehicle)
        .then((response) => {
          self.$message(
            self.$t('vehicle.messages.successTitle'),
            self.$t('vehicle.messages.saveSuccess'),
            "success"
          );
          self.$loading(false);
          this.$router.push("/vehicles");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getVehicle: function (id) {
      const self = this;
      const api = self.$store.state.api + "vehicles/" + id;

      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.vehicle = response.data.data[0];
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
    getTypeVehicles: function () {
      const self = this;
      let api =
        self.$store.state.api + "vehicle_types?status=1&paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.vehicle_types = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCompanies: function () {
      const self = this;
      let api = self.$store.state.api + "companies?status=1&paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    self.getTypeVehicles();
    self.getCompanies();

    let id = self.$route.params.id;
    if (id) {
      self.getVehicle(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
    Loading,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>